(() => {
  let loaded = false;
  let bootstrapQueued = false;
  let pending = false;
  let attempts = 0;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function(){ window.dataLayer.push(arguments); };
  function clearGoogleCookies(analytics, marketing) {
    const names = document.cookie.split(';').map(cookie=>cookie.split('=')[0].trim()).filter(name=>(!analytics && /^_ga(?:_|$)/.test(name)) || (!marketing && /^_gcl_/.test(name)));
    const host = location.hostname;
    const parts = host.split('.');
    const domains = ['',host,...parts.map((_,i)=>parts.slice(i).join('.')).filter(value=>value.includes('.'))];
    for (const name of names) for (const domain of new Set(domains)) document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax; Secure${domain?`; domain=${domain}`:''}`;
  }
  function sync() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.analyticsProcessingAllowed || !privacy?.marketingAllowed) return;
    const analytics = privacy.analyticsProcessingAllowed();
    const marketing = privacy.marketingAllowed();
    window.gtag('consent','update',{analytics_storage:analytics?'granted':'denied',ad_storage:marketing?'granted':'denied',ad_user_data:marketing?'granted':'denied',ad_personalization:marketing?'granted':'denied'});
    clearGoogleCookies(analytics,marketing);
    if (analytics && marketing && !loaded) {
      loaded = true;
      if (!bootstrapQueued) {
        bootstrapQueued = true;
        window.dataLayer.push({'gtm.start':Date.now(),event:'gtm.js'});
      }
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-MLDPBMV';
      // A failed download has not installed the container. Allow the next
      // native consent update to retry, without changing any consent choice.
      script.onerror = () => { loaded = false; };
      document.head.append(script);
    }
    document.dispatchEvent(new CustomEvent('disangni:privacy-ready'));
  }
  function boot() {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) {sync();return;}
    if (window.Shopify?.loadFeatures && !pending) {
      pending=true;
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{pending=false;if(!error)sync();});
    } else if (++attempts<30) setTimeout(boot,200);
  }
  document.addEventListener('visitorConsentCollected',sync);
  boot();
})();
